import axios from './axios'

export function getVehicleList() {
  return axios({
    method: "get",
    url: '/api/v1/vehicle?type=Truck'
  })
}

export function createVehicle(sub) {
  return axios({
    method: "post",
    url: '/api/v1/vehicle/',
    data: sub
  })
}

export function updateVehicle(id,sub) {
  return axios({
    method: "put",
    url: '/api/v1/vehicle/' + id + '/',
    data: sub
  })
}

export function deleteVehicle(id) {
  return axios({
    method: "delete",
    url: '/api/v1/vehicle/' + id + '/'
  })
}

export function getVehicleByID(id) {
  return axios({
    method: "get",
    url: '/api/v1/vehicle/' + id + '/'
  })
}